export const FLAG_GETTING_LEGAL_TICKETS = 'FLAG_GETTING_LEGAL_TICKETS';
export const GET_LEGAL_TICKETS = 'GET_LEGAL_TICKETS';
export const CLEAR_LEGAL_TICKETS = 'CLEAR_LEGAL_TICKETS';
export const FLAG_LEGAL_TICKET_ACTIVITY = 'FLAG_LEGAL_TICKET_ACTIVITY';
export const GET_LEGAL_TICKET = 'GET_LEGAL_TICKET';
export const CLEAR_LEGAL_TICKET = 'CLEAR_LEGAL_TICKET';